import { useEffect } from "react";

export function Seo({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} — ERRAH`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
      m.content = description;
    }
  }, [title, description]);
  return null;
}
